module.exports = __webpack_public_path__ + "static/media/slide-mobile (10).05755ae1.jpg";